import React from "react";
export default function Seometa() {
  const siteUrl = "https://muensterland-industrieservice.com";
  const metaTitle = "Hochdruckreinigung & Gartenpflege in Havixbeck | Münsterland Industrieservice UG";
  const metaDescription = "Münsterland Industrieservice UG bietet umweltfreundliche Hochdruck- & Steinreinigung, Gartenpflege und Hausmeisterservice in Havixbeck & Münsterland. Ohne Chemie, nur mit Wasser und Hochdrucktechnik.";
  const ogImageUrl = `${siteUrl}/img/og_share_image.webp`;
  return <section id="seometa" className="hidden" aria-hidden="true">
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={siteUrl} />

      {}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:locale:alternate" content="en_US" />
      <meta property="og:site_name" content="Münsterland Industrieservice UG" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:image:alt" content="Münsterland Industrieservice UG - Hochdruckreinigung und Gartenpflege in Havixbeck" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={siteUrl} />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImageUrl} />
    </section>;
}